export const PERMISSION_ACTIONS = {
    read: {
        name: 'read',
        label: 'Leer',
        width: '100px',
        visible: 'readVisible',
    },
    create: {
        name: 'create',
        label: 'Crear',
        width: '100px',
        visible: 'createVisible',
    },
    update: {
        name: 'update',
        width: '100px',
        label: 'Actualizar',
        visible: 'updateVisible',
    },
    delete: {
        name: 'delete',
        width: '100px',
        label: 'Eliminar',
        visible: 'deleteVisible',
    },
    export: {
        name: 'export',
        width: '100px',
        label: 'Exportar',
        visible: 'exportVisible',
    },
    import: {
        name: 'import',
        width: '100px',
        label: 'Importar',
        visible: 'importVisible',
    },
    recover: {
        name: 'recover',
        width: '100px',
        label: 'Recuperar',
        visible: 'recoverVisible',
    },
    viewCommentNomina: {
        width: '200px',
        name: 'viewCommentNomina',
        label: 'Ver comentarios',
        visible: 'viewCommentNominaVisible',
    },
    addCommentNomina: {
        width: '200px',
        name: 'addCommentNomina',
        label: 'Agregar comentarios',
        visible: 'addCommentNominaVisible',
    },
    payrollPendingAuthorize: {
        width: '200px',
        name: 'payrollPendingAuthorize',
        label: 'Enviar a pendiente de autorización',
        visible: 'payrollPendingAuthorizeVisible',
    },
    payrollAuthorized: {
        width: '200px',
        name: 'payrollAuthorized',
        label: 'Enviar a autorizada',
        visible: 'payrollAuthorizedVisible',
    },
    payrollUnauthorized: {
        width: '200px',
        name: 'payrollUnauthorized',
        label: 'Enviar a no autorizada',
        visible: 'payrollUnauthorizedVisible',
    },
    bankLayoutSendToCreated: {
        width: '200px',
        name: 'bankLayoutSendToCreated',
        label: 'Enviar a creado',
        visible: 'bankLayoutSendToCreatedVisible',
    },
    bankLayoutSendToCompleted: {
        width: '200px',
        name: 'bankLayoutSendToCompleted',
        label: 'Enviar a completado',
        visible: 'bankLayoutSendToCompletedVisible',
    },
    bankLayoutSendToGenerated: {
        width: '200px',
        name: 'bankLayoutSendToGenerated',
        label: 'Enviar a generado',
        visible: 'bankLayoutSendToGeneratedVisible',
    },
    invoiceCancel: {
        width: '200px',
        name: 'invoiceCancel',
        label: 'Cancelar factura',
        visible: 'invoiceCancelVisible',
    },
};

export const PERMISSION_SUBJECTS = {
    home: {
        name: 'home'
    },
    calendar: {
        name: 'calendar',
        pluralLabel: 'Calendario'
    },
    notifications: {
        name: 'notifications',
        pluralLabel: 'Notificaciones',
    },
    authorizationTokens: {
        name: 'authorizationTokens',
        pluralLabel: 'Tokens',
    },
    client: {
        name: 'client',
        pluralLabel: 'Clientes',
        config: {
            import: {
                entities: [
                    {
                        label: 'Información General',
                        enum: 'CLIENTES'
                    },
                    {
                        label: 'Empresas Asociadas',
                        enum: 'CLIENTES_EMPRESAS_PAGADORAS'
                    }
                ]
            }
        }
    },
    employee: {
        name: 'employee',
        pluralLabel: 'Empleados',
        config: {
            import: {
                entities: [
                    {
                        label: 'Información General',
                        enum: 'EMPLEADOS'
                    },
                    {
                        label: 'Cuentas Bancarias',
                        enum: 'EMPLEADOS_CUENTAS_BANCARIAS'
                    },
                    {
                        label: 'Empresas Asociadas',
                        enum: 'EMPLEADOS_EMPRESAS_PAGADORAS'
                    }
                ]
            }
        }
    },
    incidents: {
        name: 'incidents',
        pluralLabel: 'Incidencias',
        config: {
            import: {
                entities: [
                    {
                        label: 'Incidencias',
                        enum: 'INCIDENCIAS'
                    },
                ]
            }
        }
    },
    paymentStrategies: {
        name: 'paymentStrategies',
        pluralLabel: 'Estrategias de Pago',
    },
    payroll: {
        name: 'payroll',
        pluralLabel: 'Nóminas'
    },
    bankLayouts: {
        name: 'bankLayouts',
        pluralLabel: 'Layouts Bancarios',
    },
    payrollReceipts: {
        name: 'payrollReceipts',
        pluralLabel: 'Recibos de Nóminas'
    },
    company: {
        name: 'company',
        pluralLabel: 'Empresas',
        config: {
            import: {
                entities: [
                    {
                        label: 'Información General',
                        enum: 'EMPRESAS'
                    },
                    {
                        label: 'Cuentas Bancarias',
                        enum: 'EMPRESAS_CUENTAS_BANCARIAS'
                    },
                    {
                        label: 'Registros Patronales',
                        enum: 'EMPRESAS_REGISTROS_PATRONALES'
                    },
                ]
            }
        }
    },
    promoter: {
        name: 'promoter',
        pluralLabel: 'Promotores'
    },
    payrollConcept: {
        name: 'payrollConcept',
        pluralLabel: 'Conceptos'
    },
    commissionExpense: {
        name: 'commissionExpense',
        pluralLabel: 'Gastos de Comisión'
    },
    treasuries: {
        name: 'treasuries',
        pluralLabel: 'Tesorerías'
    },
    bankConciliation: {
        name: 'bankConciliation',
        pluralLabel: 'Conciliaciones Bancarias'
    },
    dailyConciliation: {
        name: 'dailyConciliation',
        pluralLabel: 'Conciliaciones Diarias'
    },
    bankTransaction: {
        name: 'bankTransaction',
        pluralLabel: 'Movimientos Bancarios'
    },
    reportTreasury: {
        name: 'reportTreasury',
        pluralLabel: 'Reporte de Tesorerías',
    },
    reportBankConciliation: {
        name: 'reportBankConciliation',
        pluralLabel: 'Reporte de Conciliaciones Bancarias',
    },
    reportEmployeeAccumulated: {
        name: 'reportEmployeeAccumulated',
        pluralLabel: 'Reporte Acumulado de Empleados',
    },
    user: {
        name: 'user',
        pluralLabel: 'Usuarios'
    },
    invitation: {
        name: 'invitation',
        pluralLabel: 'Invitaciones'
    },
    emails: {
        name: 'emails',
        pluralLabel: 'Correos Electrónicos'
    },
    expedients: {
        name: 'expedients',
        pluralLabel: 'Expedientes Digitales',
    },
    imports: {
        name: 'imports',
        pluralLabel: 'Importaciones',
    },
    alerts: {
        name: 'alerts',
        pluralLabel: 'Alertas',
    },
    products: {
        name: 'products',
        pluralLabel: 'Productos',
    },
    intervalsPeriodicities: {
        name: 'intervalsPeriodicities',
        pluralLabel: 'Intervalos Periodicidades',
    },
    fiscalParameters: {
        name: 'fiscalParameters',
        pluralLabel: 'Parámetros Fiscales',
    },
    authorizationActions: {
        name: 'authorizationActions',
        pluralLabel: 'Acciones',
    },
    invoices: {
        name: 'invoices',
        pluralLabel: 'Facturas',
    },
    catalogs: {
        name: 'catalogs',
        pluralLabel: 'Catálogos',
    },
};


export const arrangeImportItemsBySubject = (props = {}) => {
    const {subject} = props;
    const response = [];
    if (subject) {
        const subjectData = PERMISSION_SUBJECTS[subject];
        if (subjectData?.config?.import?.entities) {
            const entities = subjectData.config.import.entities;
            if (entities && entities.length > 0) {
                entities.forEach(entity => {
                    response.push({
                        labelSubject: entity.label,
                        enumSubject: entity.enum,
                        pluralSubjectLabel: subjectData.pluralLabel
                    })
                });
            }
        }
    }

    return response;
}
